import solicitacoesRotas from './consultorias/SolicitacoesRotas'
import consultoriasRotas from './consultorias/ConsultoriasRotas'
import pagamentosRotas from './pagamentos/PagamentosRotas'

export default {
    path: 'fornecedor',
    name: 'AppSebrae_Consultorias_Fornecedor',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [solicitacoesRotas, consultoriasRotas, pagamentosRotas]
}
